module.exports = __webpack_public_path__ + "img/guide12.6f0c4028.jpg";